import { inject, Pipe, PipeTransform } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { Files } from "../../../../api/packbo/models/files";

@Pipe({
    name: "fileSize",
    pure: false
})
export class FileSizePipe implements PipeTransform {
    private readonly translocoService = inject(TranslocoService);

    public transform(value: string | Files | null | undefined): string {
        if (!value || typeof value !== "object") {
            return "";
        }

        if (typeof value === "string") {
            return "";
        }

        if (!value.filesize) {
            return "";
        }

        const fileSizeInKB = value.filesize / 1024;
        const fileSizeInMB = fileSizeInKB / 1024;

        if (fileSizeInMB > 1) {
            return `(${fileSizeInMB.toFixed(2)}${this.translocoService.translate("unit.megabytes")})`;
        } else if (fileSizeInKB > 1) {
            return `(${fileSizeInKB.toFixed(2)}${this.translocoService.translate("unit.kilobytes")})`;
        } else {
            return `(${value}${this.translocoService.translate("unit.bytes")})`;
        }
    }
}
